// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"fe279a33","119":"b1fa4e1d","138":"70e1dc86","321":"54b24ce6","401":"33753b03","453":"9026a545","454":"78f3e82e","515":"a37e3bb2","546":"08f110bf","636":"651a5fa9","916":"ef80718f"}[chunkId] + ".chunk.js";
};